export const getSafeName = (name: string | undefined) =>
  name
    ? name
        .replace(/\s+/gi, "-")
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toLowerCase()
    : "export";
